import { Box } from '@mui/material';
import { DocumentUploadSection } from '../documentUploadSection';
import { useEffect, useState } from 'react';
import { UserDocumentTypes } from '../../../constants/userDocuments';
import { FinancialDocument } from '../financialDocument';
import { UserService } from '../../../services/userService';
import { ConnectBankSection } from '../connectBankSection';
import { SystemSettingsService } from '../../../services/systemSettingsService';

export const BorrowerKSADocuments = ({ onAllFileUploaded = (e) => { } }) => {
	const userService = new UserService();
	const systemSettingsService = new SystemSettingsService();
	const isLeanEnabled = systemSettingsService.systemSettings()?.leanEnabled;
	const [documents, setDocuments] = useState([]);
	const [isBankConnected, setIsBankConnected] = useState(!isLeanEnabled);
	const [vatReport, setVatReport] = useState(null);
	const [supportingDocument, setSupportingDocument] = useState(null);
	const [isFSUploaded, setIsFSUploaded] = useState(false);
	const [loading, setLoading] = useState(true);

	const [loadingUploadDocs, setLoadingUploadDocs] = useState({
		[UserDocumentTypes.BorrowerOtherSupportingDocuments]: false,
		[UserDocumentTypes.BorrowerVatReport]: false,
	});

	useEffect(() => {
		getAllDocuments();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (isBankConnected && supportingDocument?.length && isFSUploaded && vatReport?.length) {
			onAllFileUploaded && onAllFileUploaded(true);
		} else {
			onAllFileUploaded && onAllFileUploaded(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isBankConnected, supportingDocument, isFSUploaded, vatReport]);

	const getAllDocuments = () => {
		startStopLoader(null, null, true, true);
		userService
			.getAllDocuments()
			.then((resp) => {
				setDocuments(resp.data);
				setFiles(resp.data);
				setLoading(false);
				startStopLoader(null, null, true, false);
			})
			.catch(() => {
				setLoading(false);
				startStopLoader(null, null, true, false);
			});
	};

	const startStopLoader = (type, value, all = false, allValue = false) => {
		if (all) {
			const loaders = {
				[UserDocumentTypes.BorrowerOtherSupportingDocuments]: allValue,
				[UserDocumentTypes.BorrowerVatReport]: allValue,
			};
			setLoadingUploadDocs(loaders);
		} else {
			setLoadingUploadDocs((prevState) => ({
				...prevState,
				[type]: value,
			}));
		}
	};

	const setFiles = (fileDetails) => {
		setSupportingDocument(
			getFilteredDocuments(
				fileDetails,
				UserDocumentTypes.BorrowerOtherSupportingDocuments,
				true
			)
		);
		setVatReport(
			getFilteredDocuments(
				fileDetails,
				UserDocumentTypes.BorrowerVatReport,
				true
			)
		);
	};

	const getFilteredDocuments = (fileDetails = [], type, isMultiple = false) => {
		let files = fileDetails.filter((data) => data.type === type) || null;
		return files ? (isMultiple ? files : files[0]) : null;
	};

	return (
		<Box className="flex flex-col space-y-8">
			<Box className={`flex flex-col space-y-4`}>
				{isLeanEnabled ? (
					<ConnectBankSection
						onConnectedChange={(isConnected) => {
							setIsBankConnected(!!isConnected);
						}}
					/>
				) : null}

				<DocumentUploadSection
					isMultiple
					onRemoveFile={(e) => {
						setVatReport(e);
					}}
					onUploadedFiles={(e) => {
						setVatReport(e?.file);
					}}
					fileName="vatReportforLast4years"
					file={vatReport}
					isLoading={loadingUploadDocs[UserDocumentTypes.BorrowerVatReport]}
					fileType={UserDocumentTypes.BorrowerVatReport}
				></DocumentUploadSection>

				{!loading ? (
					<FinancialDocument
						onFileUploaded={(e) => {
							setIsFSUploaded(e);
						}}
						documents={documents}
						showOTPAuth={false}
					/>
				) : null}

				<DocumentUploadSection
					isMultiple
					onRemoveFile={(e) => {
						setSupportingDocument(e);
					}}
					onUploadedFiles={(e) => {
						setSupportingDocument(e?.file);
					}}
					subPoints={'otherSupportingDocumentPoint'}
					fileName="otherSupportingDocument"
					file={supportingDocument}
					isLoading={
						loadingUploadDocs[
						UserDocumentTypes.BorrowerOtherSupportingDocuments
						]
					}
					fileType={
                        UserDocumentTypes.BorrowerOtherSupportingDocuments
                    }></DocumentUploadSection>
			</Box>
		</Box>
	);
};
